import { useRef, useEffect } from 'react'
import { router } from '@inertiajs/react'
import { Search, X } from 'lucide-react'
import { Input } from '@/components/ui/input'

type SearchInputProps = {
  value: string
  placeholder?: string
}

export function SearchInput({ value, placeholder = 'Search...' }: SearchInputProps) {
  const inputRef = useRef<HTMLInputElement>(null)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  const handleChange = (newValue: string) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => {
      router.get(window.location.pathname, newValue ? { search: newValue } : {}, {
        preserveState: true,
        preserveScroll: true,
        replace: true,
      })
    }, 300)
  }

  const handleClear = () => {
    if (inputRef.current) inputRef.current.value = ''
    router.get(window.location.pathname, {}, {
      preserveState: true,
      preserveScroll: true,
      replace: true,
    })
  }

  return (
    <div className="relative w-full">
      <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground" />
      <Input
        ref={inputRef}
        defaultValue={value}
        onChange={e => handleChange(e.target.value)}
        placeholder={placeholder}
        className="h-8 pl-8 pr-8 text-sm"
      />
      {value && (
        <button onClick={handleClear} className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground">
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  )
}
